import { Link } from "react-router-dom";
import { money, regCode, EDITION_STYLE } from "../../lib/api";

const HEADERS = ["Registry", "Edition", "Type", "Dedication", "Customer", "Delivery", "Status", "Amount", ""];

export const RegistriesTab = ({ registries }) => (
  <div className="hy-card mt-12 overflow-x-auto" data-testid="admin-registries">
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left text-[0.6rem] uppercase tracking-widest text-slate-500 border-b border-amber-500/15">
          {HEADERS.map((h, i) => <th key={h || `col-${i}`} className="p-4 font-normal">{h}</th>)}
        </tr>
      </thead>
      <tbody>
        {registries.map((r) => (
          <tr key={r.registry_id} className="border-b border-amber-500/8" data-testid={`admin-row-${r.registry_id}`}>
            <td className="p-4 font-mono-hy text-xs text-amber-200">
              {r.number_confirmed ? regCode(r.registry_number) : `Reserved #${String(r.registry_number ?? 0).padStart(4, "0")}`}
            </td>
            <td className="p-4">
              <span className={`text-[0.55rem] uppercase px-2 py-1 border rounded-full ${EDITION_STYLE[r.edition]}`}>{r.edition}</span>
            </td>
            <td className="p-4 text-slate-400">{r.registry_type}</td>
            <td className="p-4 text-slate-200">{r.dedication_name}</td>
            <td className="p-4 text-slate-500 text-xs">{r.customer_email}</td>
            <td className="p-4 text-slate-400 text-xs max-w-[14rem]" data-testid={`admin-address-${r.registry_id}`}>
              {r.delivery_address
                ? [r.delivery_address.full_name, r.delivery_address.line1, r.delivery_address.line2,
                   r.delivery_address.city, r.delivery_address.state, r.delivery_address.postal_code,
                   r.delivery_address.country].filter(Boolean).join(", ")
                : "—"}
              {r.delivery_address?.phone && <div className="text-slate-500">{r.delivery_address.phone}</div>}
            </td>
            <td className={`p-4 text-xs ${r.payment_status === "PAID" ? "text-emerald-400" : "text-amber-400"}`}>{r.payment_status}</td>
            <td className="p-4 text-slate-300">{money(r.amount)}</td>
            <td className="p-4"><Link to={`/registry/${r.registry_id}`} className="text-amber-300 text-xs underline">View</Link></td>
          </tr>
        ))}
      </tbody>
    </table>
    {registries.length === 0 && <p className="p-8 text-slate-500 text-sm">No registry records yet.</p>}
  </div>
);

export const UsersTab = ({ users }) => (
  <div className="hy-card mt-12 overflow-x-auto" data-testid="admin-users">
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left text-[0.6rem] uppercase tracking-widest text-slate-500 border-b border-amber-500/15">
          {["Name", "Email", "Role", "Provider", "Records", "Joined"].map((h) => <th key={h} className="p-4 font-normal">{h}</th>)}
        </tr>
      </thead>
      <tbody>
        {users.map((u) => (
          <tr key={u.user_id} className="border-b border-amber-500/8">
            <td className="p-4 text-slate-200">{u.name}</td>
            <td className="p-4 text-slate-400 text-xs">{u.email}</td>
            <td className="p-4 text-xs text-amber-300">{u.role}</td>
            <td className="p-4 text-xs text-slate-500">{u.auth_provider}</td>
            <td className="p-4 text-slate-300">{u.registry_count}</td>
            <td className="p-4 text-xs text-slate-500">{(u.created_at || "").slice(0, 10)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
